import { render, staticRenderFns } from "./CurrentYear.vue?vue&type=template&id=2af43efb&"
import script from "./CurrentYear.vue?vue&type=script&lang=js&"
export * from "./CurrentYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2af43efb')) {
      api.createRecord('2af43efb', component.options)
    } else {
      api.reload('2af43efb', component.options)
    }
    module.hot.accept("./CurrentYear.vue?vue&type=template&id=2af43efb&", function () {
      api.rerender('2af43efb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2LrfuiVgLEUZK/JS/comp/CurrentYear.vue"
export default component.exports